import { render, staticRenderFns } from "./addUserDialog.vue?vue&type=template&id=b64aa0be&scoped=true"
import script from "./addUserDialog.vue?vue&type=script&lang=js"
export * from "./addUserDialog.vue?vue&type=script&lang=js"
import style0 from "./addUserDialog.vue?vue&type=style&index=0&id=b64aa0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64aa0be",
  null
  
)

export default component.exports